import React, { useEffect, useState } from 'react';

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [newsItems, setNewsItems] = useState([]);
  
  useEffect(() => {
    setIsVisible(true);
    
    // Создаем реалистичные "новостные блоки" для анимации
    const dummyNews = [
      { 
        id: 1, 
        delay: 0, 
        title: 'Теннисистки поделились секретом поддержания красивой фигуры',
        category: 'Спорт', 
        color: '#01579b',
        icon: 'sports_tennis'
      },
      { 
        id: 2, 
        delay: 0.2, 
        title: 'Как правильно выбрать новую мебель: лайфхак от дизайнеров',
        category: 'Дизайн', 
        color: '#388e3c',
        icon: 'chair'
      },
      { 
        id: 3, 
        delay: 0.4, 
        title: 'Новые технологии в сфере искусственного интеллекта',
        category: 'Технологии', 
        color: '#6a1b9a',
        icon: 'memory'
      },
      { 
        id: 4, 
        delay: 0.6, 
        title: 'Исследование: как социальные сети влияют на психику',
        category: 'Здоровье', 
        color: '#d32f2f',
        icon: 'psychology'
      },
      { 
        id: 5, 
        delay: 0.8, 
        title: 'Топ-10 популярных туристических направлений этого года',
        category: 'Путешествия', 
        color: '#f57c00',
        icon: 'flight'
      }
    ];
    
    setNewsItems(dummyNews);
    
    // Интервал для "обновления" новостей в анимации
    const interval = setInterval(() => {
      setNewsItems(prev => {
        const newItems = [...prev];
        // Перемешиваем индексы для эффекта обновления
        newItems.sort(() => Math.random() - 0.5);
        return newItems;
      });
    }, 5000);
    
    return () => clearInterval(interval);
  }, []);
  
  // Стили компонентов
  const styles = {
    container: {
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'linear-gradient(135deg, #2b3f76, #373476)',
      color: 'white',
      fontFamily: 'Segoe UI, Roboto, sans-serif',
      overflow: 'hidden',
      position: 'relative'
    },
    contentWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      padding: '2rem',
      maxWidth: '800px',
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
      transition: 'opacity 1s ease, transform 1s ease',
      zIndex: 2
    },
    title: {
      fontSize: '4.5rem',
      fontWeight: '700',
      marginBottom: '1.5rem',
      color: 'white',
      textShadow: '0 0 20px rgba(255, 255, 255, 0.3)',
      letterSpacing: '-1px'
    },
    subtitle: {
      fontSize: '1.8rem',
      marginBottom: '2.5rem',
      lineHeight: '1.4',
      maxWidth: '600px',
      fontWeight: '500',
      color: 'rgba(255, 255, 255, 0.9)'
    },
    infoBox: {
      padding: '1.2rem 2.5rem',
      background: 'rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(10px)',
      borderRadius: '50px',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      display: 'flex',
      alignItems: 'center',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      cursor: 'pointer'
    },
    infoText: {
      fontSize: '1.2rem',
      fontWeight: '500'
    },
    iconContainer: {
      marginLeft: '10px',
      fontSize: '1.5rem',
      display: 'inline-block',
      animation: 'spin 2s infinite linear'
    },
    newsWrapper: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      zIndex: 1
    },
    newsItem: (delay, position) => ({
      position: 'absolute',
      padding: '0',
      background: '#1e2235',
      borderRadius: '12px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
      color: 'white',
      animation: `newsFlow 20s infinite ease-out ${delay}s`,
      left: `${position.left}%`,
      bottom: `-100px`,
      width: `${position.width}px`,
      opacity: 0,
      overflow: 'hidden'
    }),
    newsImageContainer: {
      width: '100%',
      height: '140px',
      backgroundColor: '#242842',
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    iconBackground: (color) => ({
      width: '70px',
      height: '70px',
      backgroundColor: color,
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxShadow: `0 5px 15px ${color}50`
    }),
    materialIcon: {
      fontSize: '40px',
      color: 'white'
    },
    adTag: {
      position: 'absolute',
      top: '10px',
      left: '10px',
      background: 'rgba(0, 0, 0, 0.3)',
      padding: '3px 8px',
      borderRadius: '4px',
      fontSize: '12px',
      color: 'rgba(255, 255, 255, 0.8)'
    },
    categoryTag: (color) => ({
      position: 'absolute',
      bottom: '10px',
      left: '10px',
      background: color,
      padding: '4px 10px',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: 'bold'
    }),
    newsContent: {
      padding: '15px',
    },
    newsTitle: {
      fontSize: '15px',
      fontWeight: 'bold',
      lineHeight: '1.3',
      margin: 0,
      textAlign: 'left'
    },
    '@keyframes newsFlow': {
      '0%': {
        transform: 'translateY(0)',
        opacity: 0
      },
      '5%': {
        transform: 'translateY(-100px)',
        opacity: 0.95
      },
      '80%': {
        transform: 'translateY(-800px)',
        opacity: 0.4
      },
      '100%': {
        transform: 'translateY(-1000px)',
        opacity: 0
      }
    },
    '@keyframes pulse': {
      '0%': {
        transform: 'scale(1)',
        opacity: 1
      },
      '50%': {
        transform: 'scale(1.5)',
        opacity: 0.7
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 1
      }
    },
    '@keyframes spin': {
      '0%': {
        transform: 'rotate(0deg)'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    }
  };
  
  // Генерация случайной позиции для новостного блока
  const getRandomPosition = (id) => {
    const positions = [
      { left: 5, width: 220 },
      { left: 23, width: 250 },
      { left: 42, width: 230 },
      { left: 62, width: 240 },
      { left: 78, width: 220 }
    ];
    return positions[id % positions.length];
  };
  
  // Компонент для отображения иконки Material Icons
  const MaterialIcon = ({ icon }) => (
    <span style={{ fontFamily: 'Material Icons', fontSize: '40px' }}>
      {icon}
    </span>
  );
  
  return (
    <div style={styles.container}>
      <style>
        {`
          @import url('https://fonts.googleapis.com/icon?family=Material+Icons');
          
          @keyframes newsFlow {
            0% { transform: translateY(0); opacity: 0; }
            5% { transform: translateY(-100px); opacity: 0.95; }
            80% { transform: translateY(-800px); opacity: 0.4; }
            100% { transform: translateY(-1000px); opacity: 0; }
          }
          @keyframes pulse {
            0% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.5); opacity: 0.7; }
            100% { transform: scale(1); opacity: 1; }
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      
      <div style={styles.contentWrapper}>
        <h1 style={styles.title}>Агрегатор Новостей</h1>
        
        <div style={styles.subtitle}>
          Новый агрегатор новостей скоро будет доступен...
        </div>
        
        <div style={{
          ...styles.infoBox,
          transform: isVisible ? 'scale(1)' : 'scale(0.8)',
        }}>
          <span style={styles.infoText}>Следите за обновлениями</span>
          <span style={styles.iconContainer}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 5H20V7H4V5Z" fill="white"/>
              <path d="M4 9H20V11H4V9Z" fill="white"/>
              <path d="M4 13H20V15H4V13Z" fill="white"/>
              <path d="M4 17H12V19H4V17Z" fill="white"/>
            </svg>
          </span>
        </div>
      </div>
      
      <div style={styles.newsWrapper}>
        {newsItems.map(item => (
          <div 
            key={item.id} 
            style={styles.newsItem(item.delay, getRandomPosition(item.id))}
          >
            <div style={styles.newsImageContainer}>
              <div style={styles.iconBackground(item.color)}>
                <MaterialIcon icon={item.icon} />
              </div>
              <div style={styles.adTag}>Реклама</div>
              <div style={styles.categoryTag(item.color)}>{item.category}</div>
            </div>
            <div style={styles.newsContent}>
              <h3 style={styles.newsTitle}>{item.title}</h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Home;